import React from "react";
import style from "./AboutEventDetails.module.css";
import Image from "next/image";
import Link from "next/link";
import CustomiseCta from "../CustomiseCta/CustomiseCta";

interface AboutEventDetailsProps {
  image: any;
  aboutEvent: any;
  eventVenue: any;
  saveDataOnVinecrm?: boolean;
  formFieldsSection?: any;
  EventTitle?: string;
}

const AboutEventDetails: React.FC<AboutEventDetailsProps> = ({
  aboutEvent,
  image,
  eventVenue,
  saveDataOnVinecrm,
  formFieldsSection,
  EventTitle,
}: any) => {
  return (
    <div className="container">
      <div className={style.aboutEventDetailsRow}>
        <div className={style.aboutEvents}>
          <Image
            src={image?.url}
            alt={image?.alternativeText || "image"}
            className={style.logo}
            width={1025}
            height={342}
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "1025px",
              aspectRatio: "1025/342",
            }}
          />
          <h2>{aboutEvent?.title}</h2>

          <div
            className={style.description}
            dangerouslySetInnerHTML={{ __html: aboutEvent?.description }}
          />
          {aboutEvent?.card_title_and_description?.length > 0 && (
            <ul className={style.cardList}>
              {aboutEvent?.card_title_and_description.map((item: any) => (
                <li key={item.id}>
                  <strong>{item?.title}</strong>
                  <p>{item?.description}</p>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Event Venue Section */}
        <div className={style.eventVenue}>
          <h3>{eventVenue.title}</h3>
          <div className={style.venueCard}>
            <div className={style.flexDetails}>
              <div>
                <strong>Venue:</strong> {eventVenue?.venue}
              </div>
              <div>
                <strong>Location:</strong> {eventVenue?.location}
              </div>
              <div>
                <strong>Phone Number:</strong> (+{eventVenue?.country_code}) {eventVenue?.phone_number}
              </div>
              <div>
                <strong>Web Site:</strong>
                <div>
                  <p>{eventVenue?.web_site}</p>
                  <Link
                    href={`https://${eventVenue.web_stie}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {eventVenue.web_stie}
                  </Link>

                  <div className="social-icons d-flex justify-content-center align-items-center gap-2">
                    {eventVenue?.icon_url.map((item: any) => (
                      <Link
                        href={
                          item?.url?.startsWith("http")
                            ? item?.url
                            : `https://${item?.url}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        key={item?.id}
                      >
                        <Image
                          src={item?.icon?.url}
                          alt={item?.icon?.alternativeText || "social-icon"}
                          title={item?.icon?.alternativeText || "social-icon"}
                          width={16}
                          height={16}
                          layout="intrinsic"
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className={style.socialMedia}>
              {eventVenue?.socialMedia?.map((media: any, index: any) => (
                <Link
                  key={index}
                  href={media.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={`fab fa-${media.platform}`}></i>
                </Link>
              ))}
            </div>
          </div>
          <div className={style.registerButton}>
            <CustomiseCta
              btnLabelDesktop={eventVenue.button_text}
              saveEvenCmsData={!saveDataOnVinecrm}
              saveDataOnVinecrm={saveDataOnVinecrm}
              formFieldsSection={formFieldsSection}
              EventTitle={EventTitle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutEventDetails;
